import type { NotificationPreference } from '@seek/hirer-notification-preference';
import type { TeamMemberForJobAccess } from '@seek/hirer-team-member-job-access';

import * as actions from 'src/app/state/modules/session/notificationsSetting';

export const dispatchSetSavedNotificationPreference = (
  notificationPreference?: NotificationPreference,
) => actions.actionSetSavedNotificationPreference(notificationPreference);

export const dispatchUpdateActiveNotificationStep = (stepIndex: number) =>
  actions.actionUpdateActiveNotificationStep(stepIndex);

export const dispatchUpdateIncludeSendEmailStep = (
  hasTeamMemberNotifySelected: boolean,
) =>
  actions.actionUpdateHasTeamMemberNotifySelected(hasTeamMemberNotifySelected);

export const dispatchStartSettingMode = () => actions.actionStartSettingMode();

export const dispatchCompleteSetting = () => actions.actionCompleteSetting();

export const dispatchSettingWithServerError = () =>
  actions.actionSettingWithServerError();

export const dispatchSetSavedTeamMemberJobAccessList = (
  teamMemberJobAccessList?: TeamMemberForJobAccess[],
) => actions.actionSetSavedTeamMemberJobAccessList(teamMemberJobAccessList);

export const dispatchResetTeamMemberNotifyState = (stepIndex: number) =>
  actions.actionResetTeamMemberNotifyState(stepIndex);

export const dispatchResetNotificationSettings = () =>
  actions.actionResetNotificationsSetting();

export default {
  dispatchSetSavedNotificationPreference,
  dispatchUpdateActiveNotificationStep,
  dispatchUpdateIncludeSendEmailStep,
  dispatchStartSettingMode,
  dispatchCompleteSetting,
  dispatchSettingWithServerError,
  dispatchSetSavedTeamMemberJobAccessList,
  dispatchResetNotificationSettings,
};
